import { createGlobalStyle } from "styled-components";

const CollapseStyles = createGlobalStyle`
	.ant-collapse-content > .ant-collapse-content-box {
		padding: 0px;
	}
`;

export default CollapseStyles;
